<div class="mobile-nav-title" i18n>CONTACT US</div>
<div class="container-fluid">
  <p class="col text-bidit-primary-header" i18n>Contact IDI</p>
  <div class="col text-bidit-primary ">
    <p i18n>For questions about BIDIT or IDI, please use contact information below</p>
    <div class="form-group form-inline">
      <div class=" mr-2" i18n>Email:</div>
      <div class="">
        <a class="footer-nav-link" href="mailto:BIDIT-Support@IDIMN.COM">BIDIT-Support&#64;IDIMN.COM</a>
      </div>
    </div>
  </div>
</div>
